import Swiper from 'swiper';

// eslint-disable-next-line import/no-mutable-exports
let slide = {};

// eslint-disable-next-line no-undef
if (window.innerWidth <= 768) {
  slide = new Swiper('.swiper-container', {
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 1,
    spaceBetween: 20,
  });
}

export default slide;

